/*
 * <complete-the-look>: "+" adds one product, "Add all" adds every listed product in one
 * /cart/add request (items[]), then the cart drawer is refreshed and opened, as product-card.js does.
 * When the section has no products from the metafield it loads Shopify's complementary
 * recommendations (data-url) once it nears the viewport.
 */
if (!customElements.get('complete-the-look')) {
  customElements.define(
    'complete-the-look',
    class CompleteTheLook extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => this.onClick(event));
        if (this.dataset.url && !this.querySelector('.ob-look')) this.observe();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      observe() {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      load() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const source = html.querySelector('complete-the-look');
            if (source && source.innerHTML.trim()) this.innerHTML = source.innerHTML;
          })
          .catch((error) => console.error(error));
      }

      onClick(event) {
        const single = event.target.closest('[data-look-add]');
        const all = event.target.closest('[data-look-add-all]');
        if (single) this.add([single.dataset.lookAdd], single);
        if (all) this.add(all.dataset.lookAddAll.split(',').filter(Boolean), all);
      }

      add(variantIds, button) {
        if (!variantIds.length || button.getAttribute('aria-disabled') === 'true') return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(button);
        }

        this.showError();
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        button.querySelector('.loading__spinner')?.classList.remove('hidden');

        fetch(`${window.routes.cart_add_url}.js`, { ...fetchConfig('json'), body: JSON.stringify(body) })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'complete-the-look',
                productVariantId: variantIds[0],
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showError(response.description || response.message);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'complete-the-look',
              productVariantId: variantIds[0],
              cartData: response,
            });
            this.announce(button);
            if (button.hasAttribute('data-look-add')) {
              button.classList.add('is-added');
              setTimeout(() => button.classList.remove('is-added'), 2000);
            }
            cart.classList.remove('is-empty');
            cart.renderContents({ ...response, id: response.items?.[0]?.id });
          })
          .catch((error) => {
            console.error(error);
            this.showError(window.cartStrings?.error);
          })
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            button.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      announce(button) {
        const status = this.querySelector('[data-look-status]');
        if (status) status.textContent = button.getAttribute('aria-label') || button.textContent.trim();
      }

      showError(message) {
        const error = this.querySelector('.ob-look__error');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      }
    }
  );
}
